<div @fade class="summary-main-container">
  <div class="container-position">
    <div class="entity-bank">
      <ul id="entities">
        <li class="item-a" *ngFor="let item of data.IBANS; let i = index">
          <div [ngStyle]="{'padding': '0 8px 0 0'}">
            <div class="tittle-entity">
              <div class="container-img">
                <img class="entityImg" src="./assets/global-position/summary/entities_circle/{{ item.codebank }}.png" alt="">
                {{ getNameEntity(item.codebank) }}
              </div>
              <img (click)="getBankLink(item.codebank)" *ngIf="showProfile"
                class="refresh" id="refresh_{{i}}" title="Actualizar entidad" src="./assets/global-position/main/refresh.png" alt="">
            </div>
            <p class="accounts" *ngFor="let it of item.Account">
              <span class="account">Cuenta &nbsp;&nbsp;****{{getLast4Characters(it.IdCuenta)}}</span>
              <span class="saldo">{{it.SaldoC}}</span>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="add-account-container">
      <span class="total"><span class="text-total">Saldo total:</span> {{ data.SaldoT }}</span>
      <div class="add-container">
        <p (click)="addNewAccount()"><img src="./assets/navbar/add_icon.svg" alt="">Añadir cuenta</p>
      </div>
    </div>
  </div>
  <div class="left">
    <div class="big-five-container">
      <p>¿Qué dice tu cuenta de tu Salud Financiera?</p>
      <div class="big-five" *ngFor="let item of data.score.BigFive">
        <div class="hearth-container">
          <div class="hearth">
            <img src="./assets/global-position/summary/big five/{{item.Name}}.svg" alt="">
          </div>
          <div class="name">
            {{ item.Description }}
          </div>
        </div>
        <div class="num">{{ item.Value }}</div>
      </div>
    </div>
  </div>
  <div class="right">
    <div class="background-container">
      <p>{{ getExpression() }}</p>
      <div class="scoring-container">
        <img class="scoring" src="./assets/global-position/summary/scoring/{{ data.score.ScoreNumber }}.svg" alt="">
      </div>
      <div class="share-container">
        <div class="share-scoring">Invitar &nbsp;&nbsp;<img (click)="inviteWhatsApp()"
            src="./assets/global-position/main/add-user.svg" alt="">
          &nbsp;&nbsp;&nbsp;</div>
        <div class="share-invitation">Compartir &nbsp;&nbsp;<img (click)="shareScoringWhatsApp()"
            src="./assets/global-position/main/share.svg" alt="">
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-information">
    <div class="information-container">
      <p *ngIf="aviso" style="color: red; font-size: 12px; text-align: left;">{{ aviso }}</p>
      <p class="first">¿Cómo hemos calculado tu puntación? <img style="width: 19px; cursor: pointer;"
          src="./assets/temporals/modal-information.svg" (click)="openModal()" aria-label="Informacion" alt="modal-information"></p>
      <p class="second">Dividimos tu salud financiera en 5 categorías que crean tu puntuación. Clica en cada una
        de ellas y descúbrelas con más detalle: </p>
    </div>
    <div class="categories" [hidden]="show">
      <ul id="autoWidth">
        <li class="item-a" *ngFor="let item of list">
          <div class="category" [ngStyle]="{'border-bottom': '8px solid ' + getColor(item.CategoryScoreNumber)}"
            (click)="goToCategory(item.CategoryName);">
            <p class="category-name">{{item.CategoryName}}</p>
            <p class="scoring"><span class="scoring-number"
                [ngStyle]="{'color': getColor(item.CategoryScoreNumber)}">{{item.CategoryScoreNumber}}</span>/10
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
